import type { PropertyValidationResult } from '../../../types/properties';

export default function validator(properties: Record<string, any>): PropertyValidationResult {
  const errors: Array<{ key: string; message: string }> = [];

  const resource = properties.resource;
  const operation = properties.operation;

  // Credential validation
  if (properties.useCredential && !properties.credentialId) {
    errors.push({ key: 'credentialId', message: 'A SharePoint OAuth2 credential is required when using OAuth2 authentication' });
  }

  // Site operations
  if (resource === 'site') {
    if (operation === 'get' && !properties.siteId) {
      errors.push({ key: 'siteId', message: 'Site ID is required for Get Site operation' });
    }
  }

  // List operations
  if (resource === 'list') {
    if (!properties.siteId) {
      errors.push({ key: 'siteId', message: 'Site ID is required for List operations' });
    }
    if (operation === 'get' && !properties.listId) {
      errors.push({ key: 'listId', message: 'List ID is required for Get List operation' });
    }
  }

  // List Item operations
  if (resource === 'listItem') {
    if (!properties.siteId) {
      errors.push({ key: 'siteId', message: 'Site ID is required for List Item operations' });
    }
    if (!properties.listId) {
      errors.push({ key: 'listId', message: 'List ID is required for List Item operations' });
    }
    if (['get', 'update', 'delete'].includes(operation) && !properties.itemId) {
      errors.push({ key: 'itemId', message: 'Item ID is required for this operation' });
    }
    if (['create', 'update'].includes(operation) && properties.fields) {
      try {
        JSON.parse(properties.fields);
      } catch {
        errors.push({ key: 'fields', message: 'Fields must be valid JSON' });
      }
    }
  }

  // File operations
  if (resource === 'file') {
    if (!properties.siteId) {
      errors.push({ key: 'siteId', message: 'Site ID is required for File operations' });
    }
    if (['download', 'update'].includes(operation) && !properties.fileId) {
      errors.push({ key: 'fileId', message: 'File ID is required for this operation' });
    }
    if (operation === 'upload') {
      if (!properties.fileName) {
        errors.push({ key: 'fileName', message: 'File Name is required for Upload operation' });
      }
      if (!properties.contentBase64) {
        errors.push({ key: 'contentBase64', message: 'File Content (Base64) is required for Upload operation' });
      }
    }
  }

  // Folder operations
  if (resource === 'folder') {
    if (!properties.siteId) {
      errors.push({ key: 'siteId', message: 'Site ID is required for Folder operations' });
    }
    if (operation === 'get' && !properties.folderId) {
      errors.push({ key: 'folderId', message: 'Folder ID is required for Get Folder operation' });
    }
  }

  return {
    valid: errors.length === 0,
    errors
  };
}
